import React from 'react'
import { Button, Typography, withStyles } from '@material-ui/core'
import styles from './styles'
const CustomAutomationButton = props => {
  const { onClick, buttonsClass } = props
  return (
    <Button
      onClick={() => onClick()}
      variant="contained"
      className={buttonsClass}
    >
      <Typography
        fontSize={'15px'}
        fontWeight={600}
        style={{
          marginBottom: 4,
        }}
      >
        Sign in
      </Typography>
    </Button>
  )
}

export default withStyles(styles)(CustomAutomationButton)
